'use client';

import { StandardAsset } from '$components/Asset';
import { PlayButton, PlayButtonType } from '$components/PlayButton';
import { SplitTextMulti } from '$components/SplitTextMulti/SplitTextMulti';
//import { SplitTextRows } from '$components/SplitTextRows/SplitTextRows';
import { Asset } from '$components/index';
import cn from 'classnames';
import { useCallback, useEffect, useState } from 'react';

import FadeInSection from '../FadeInSection/FadeInSection';
import ReactPlayer from '../ReactPlayer/src/index';

const typeClasses: Record<'light' | 'dark', string> = {
  light: 'text-grey-100',
  dark: 'text-white',
};

export function Video(props: {
  duration: string;
  title: string;
  poster: Asset[];
  vimeoUrl: string;
  autoplay: boolean;
  controls: boolean;
  loop: boolean;
  muted: boolean;
  type: string;
}) {
  const {
    duration,
    title,
    poster,
    vimeoUrl,
    autoplay,
    controls,
    loop,
    muted,
    type,
  } = props;
  const [loaded, setLoaded] = useState(false);
  const [showVideo, setShowVideo] = useState(false);

  const loadVideo = useCallback(() => {
    if (!loaded) setLoaded(true);
    setShowVideo(true);
  }, [loaded]);

  useEffect(() => {
    if (autoplay) loadVideo();
  }, [autoplay, loadVideo]);

  const pauseVideo = () => {
    setShowVideo(false);
  };
  const playVideo = () => {
    setShowVideo(true);
  };

  return (
    <FadeInSection>
      <div className="flex flex-row justify-center">
        <div className={`grid-standard `}>
          <div className={` col-span-4 md:col-span-12`}>
            <div className="relative aspect-w-2 aspect-h-3 md:aspect-w-16 md:aspect-h-9">
              {/*{!loaded && (*/}
              <div
                onClick={loadVideo}
                className={cn(
                  'absolute left-0 top-0 w-full h-full text-left cursor-pointer duration-1000 z-20',
                  showVideo ? 'opacity-0 pointer-events-none' : 'opacity-100',
                )}
              >
                <StandardAsset
                  className="rounded object-cover absolute left-0 top-0 z-20 w-full h-full"
                  sizes="75vw"
                  assets={poster}
                />
                <div className="absolute text-white left-0 top-0 z-30 w-full h-full">
                  <div className="absolute left-[32px] top-[32px] md:left-[64px] md:top-[64px] z-30 w-9/12">
                    <h2
                      aria-label={title}
                      className={cn(
                        typeClasses[type],
                        'style-heading-s moveText',
                      )}
                    >
                      <SplitTextMulti
                        copy={title}
                        role="heading"
                        speed={25}
                        delay={0.35}
                      />
                    </h2>
                    {/*<SplitTextRows
                        className={cn(
                          'style-heading-s',
                          typeClasses[type],
                        )}
                        as="h2"
                      >
                        {title}
                      </SplitTextRows>*/}
                  </div>
                  <div
                    className={cn(
                      'absolute left-[32px] bottom-[32px] md:left-[64px] md:bottom-[64px] z-30',
                    )}
                  >
                    <PlayButton type={type as PlayButtonType} size={'l'}>
                      {duration}
                    </PlayButton>
                  </div>
                </div>
              </div>
              {/*)}*/}
              {loaded && (
                <ReactPlayer
                  url={vimeoUrl}
                  className={cn(
                    showVideo ? 'opacity-100' : 'opacity-0',
                    'absolute left-0 top-0 w-full h-full object-cover rounded overflow-hidden duration-1000 z-10',
                  )}
                  autoPlay={autoplay}
                  width={'100%'}
                  height={'100%'}
                  playing={autoplay || showVideo}
                  controls={controls}
                  loop={loop}
                  muted={autoplay ? true : muted}
                  playsinline={false}
                  onPause={pauseVideo}
                  onPlay={playVideo}
                  config={{
                    file: {
                      hlsOptions: {
                        startLevel: 4,
                      },
                      attributes: {
                        className: 'video-child',
                      },
                    },
                  }}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </FadeInSection>
  );
}
